import { Fragment } from "react";

import { isIdentityVerificationEnabled } from "../../utils/identityVerification";

const IdentityVerificationActions = ({
  settings,
  onRequire,
  onSuppress,
  onUseDefault,
}) => {
  if (!isIdentityVerificationEnabled(settings)) {
    return null;
  }

  return (
    <Fragment>
      <li onClick={onRequire}>
        <a>
          <span uk-icon="icon: lock; ratio: 0.8" />{" "}
          Require ID verification
        </a>
      </li>
      <li onClick={onSuppress}>
        <a>
          <span uk-icon="icon: lock; ratio: 0.8" />{" "}
          Suppress ID verification
        </a>
      </li>
      <li onClick={onUseDefault}>
        <a>
          <span uk-icon="icon: refresh; ratio: 0.8" />{" "}
          Use account default
        </a>
      </li>
    </Fragment>
  );
};

export default IdentityVerificationActions;
